import React from "react";
import { connect } from "react-redux";
import { Field, FieldArray } from "formik";
import { debounce } from "lodash";
import swal from "sweetalert";
import * as Toastr from "toastr";

import { swalDefaultConfig } from "../../utils";
import { destroy, destroyAll, update } from "../redux/actions/itemsAction";
import InputNumber from "../../../DataEntry/InputNumber";
import CheckBox from "../../../DataEntry/CheckBox";
import Select from "../../../DataEntry/Select";
import PopConfirm from "../../../modal/PopConfirm";

class Table extends React.Component<any, any> {
  componentDidUpdate(prevProps: any, _prevState: any) {
    const { shippedItems, formik } = this.props;
    if (shippedItems.length !== prevProps.shippedItems.length) {
      const reconciledData = [];
      shippedItems.forEach((elm: any, idx: number) => {
        reconciledData[idx] = formik.values.items.find(
          (c: any) => c.id === elm.id,
        ) || { ...elm, checked: false };
      });
      formik.setFieldValue("all", false);
      formik.setFieldValue("items", reconciledData);
    }
  }

  handleToggleAll = (event: any) => {
    const { formik, shippedItems } = this.props;
    const checked = event.target.checked;
    const { values } = formik;
    const { items } = values;

    shippedItems.forEach((_elm: any, idx: number) => {
      items[idx] = {
        ...items[idx],
        checked: checked && items[idx].shipped_qty === "",
      };
    });

    formik.setValues({ ...values, items, all: checked }, false);
  };

  handleBlurShippedItem = debounce((idx: number) => {
    const { formik, shippedItems } = this.props;
    const row = formik.values.items[idx];
    if (row.ordered_qty == shippedItems[idx].ordered_qty) return;

    const { scheduleId, update } = this.props;
    update(scheduleId, row.id, row).catch((error: any) => {
      Toastr.error(error.message);
      formik.setFieldValue(
        `items.${idx}.ordered_qty`,
        shippedItems[idx].ordered_qty,
      );
    });
  }, 500);

  handleDestroy = (id: number) => {
    const { destroy, scheduleId } = this.props;
    destroy(scheduleId, id);
  };

  handleBulkAction = ({ target }: any) => {
    const { formik } = this.props;
    const checked = formik.values.items.filter((i: any) => i.checked);
    if (!checked.length) {
      Toastr.warning("Please select an item at least");
    } else {
      switch (target.value) {
        case "delete":
          const { destroyAll, scheduleId } = this.props;
          swal({
            ...swalDefaultConfig,
            text: "This will delete selected shipped item(s)",
          }).then((willConfirm: boolean) => {
            if (willConfirm) {
              destroyAll(scheduleId, { id: checked.map((i: any) => i.id) });
            } else {
              return false;
            }
          });
          break;
      }
    }

    formik.setFieldValue("action", "");
  };

  handleCheckItem = ({ target }: any) => {
    const { formik } = this.props;
    if (target.checked) {
      const index = parseInt(target.name.match(/\d+/)[0]);
      const checked = formik.values.items
        .filter((i: any) => i.shipped_qty === "")
        .every((i: any, idx: number) => idx === index || i.checked);

      formik.setFieldValue("all", checked);
    } else {
      formik.setFieldValue("all", false);
    }
  };

  downloadReturned = (shippedItem: any) => {
    const { clientCode, storeCode } = this.props;
    window.location.href = `/${clientCode}/${storeCode}/crm/schedules/${shippedItem.schedule_id}/items/${shippedItem.id}/returned_assets.csv`;
  };

  downloadShipped = (shippedItem: any) => {
    const { clientCode, storeCode } = this.props;
    window.location.href = `/${clientCode}/${storeCode}/crm/schedules/${shippedItem.schedule_id}/items/${shippedItem.id}/shipped_assets.csv`;
  };

  render() {
    const { deleteAllowed, editAllowed, shippedItems, viewOnly } = this.props;

    return (
      <table className="table table-hover table-bordered table-responsive smart-table">
        <thead className="cadet-gray-header">
          <tr className="center-content">
            <th style={{ width: "2%" }}>
              <Field
                name="all"
                component={CheckBox}
                onChange={this.handleToggleAll}
                disabled={viewOnly || !deleteAllowed}
              />
            </th>
            <th style={{ textAlign: "left", width: "40%" }}>Item SKU / Name</th>
            <th>Ordered QTY</th>
            <th>Shipped QTY</th>
            <th>Returned QTY</th>
            <th style={{ width: "3%" }}></th>
          </tr>
        </thead>
        <tbody>
          <FieldArray
            name="items"
            render={() =>
              shippedItems.map((si: any, idx: number) => {
                const disabled = viewOnly || si.shipped_qty !== "";

                return (
                  <tr
                    key={si.id}
                    className="center-content"
                    style={disabled ? { backgroundColor: "#F5F5F5" } : {}}
                  >
                    <td>
                      <Field
                        name={`items.${idx}.checked`}
                        component={CheckBox}
                        onChange={this.handleCheckItem}
                        disabled={disabled || !deleteAllowed}
                      />
                    </td>
                    <td className="text-left without-control">
                      {si.description} SKU: {si.sku}
                    </td>
                    <td>
                      <Field
                        name={`items.${idx}.ordered_qty`}
                        className={`smart-form-control ${disabled ? "smart-control-readonly" : ""} text-center`}
                        component={InputNumber}
                        onBlur={() => this.handleBlurShippedItem(idx)}
                        disabled={disabled || !editAllowed}
                      />
                    </td>
                    <td>
                      {si.shipped_qty && (
                        <PopConfirm
                          icon="info"
                          dangerMode={false}
                          text="This will download shipped items."
                          onConfirm={() => this.downloadShipped(si)}
                        >
                          <a className="pointer">{si.shipped_qty}</a>
                        </PopConfirm>
                      )}
                    </td>
                    <td>
                      {si.returned_qty && (
                        <PopConfirm
                          icon="info"
                          dangerMode={false}
                          text="This will download returned items."
                          onConfirm={() => this.downloadReturned(si)}
                        >
                          <a className="pointer">{si.returned_qty}</a>
                        </PopConfirm>
                      )}
                    </td>
                    <td className="sn-icons">
                      {disabled || !deleteAllowed ? (
                        <a className="fa fa-minus-circle disabled" />
                      ) : (
                        <PopConfirm
                          text="This will delete shipped item information."
                          onConfirm={() => this.handleDestroy(si.id)}
                        >
                          <a className="fa fa-minus-circle delete-icon pointer" />
                        </PopConfirm>
                      )}
                    </td>
                  </tr>
                );
              })
            }
          />
          <tr>
            <td colSpan={2}>
              <Field
                name="action"
                className="smart-form-control"
                component={Select}
                list={[
                  ["", "Select Bulk Action"],
                  ["delete", "Delete"],
                ]}
                style={{ width: "36%" }}
                onChange={this.handleBulkAction}
                disabled={viewOnly || !deleteAllowed}
              />
            </td>
            <td className="text-center bold">
              {shippedItems
                .reduce(
                  (total: any, { ordered_qty }: any) =>
                    (total += parseInt(ordered_qty || 0)),
                  0,
                )
                .toLocaleString()}
            </td>
            <td className="text-center bold">
              {shippedItems
                .reduce(
                  (total: any, { shipped_qty }: any) =>
                    (total += parseInt(shipped_qty || 0)),
                  0,
                )
                .toLocaleString()}
            </td>
            <td className="text-center bold">
              {shippedItems
                .reduce(
                  (total: any, { returned_qty }: any) =>
                    (total += parseInt(returned_qty || 0)),
                  0,
                )
                .toLocaleString()}
            </td>
            <td />
          </tr>
        </tbody>
      </table>
    );
  }
}

const mapStateToProps = (state: any, _props: any) => ({
  deleteAllowed: state.permissions.data.schedule_delete_shipped_item,
  editAllowed: state.permissions.data.schedule_edit_shipped_item,
  shippedItems: state.shippedItems.data,
});

const mapDispatchToProps = { destroy, destroyAll, update };

export default connect(mapStateToProps, mapDispatchToProps)(Table);
